/* global System */

export default {
  IconWithLink: () =>
    System.import(/* webpackChunkName: "IconWithLink" */ './index'),
}
